var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.type === 1
        ? _c(
            "div",
            {
              staticClass: "g-certi-box",
              on: {
                click: function($event) {
                  return _vm.onGetCerti("")
                }
              }
            },
            [_vm._t("default")],
            2
          )
        : _c(
            "span",
            {
              attrs: { slot: "reference" },
              on: {
                click: function($event) {
                  return _vm.onGetCerti("")
                }
              },
              slot: "reference"
            },
            [_vm._t("default")],
            2
          ),
      _vm.sSDialogVisible
        ? _c("selectSubjectDialog", {
            attrs: {
              dialogVisible: _vm.sSDialogVisible,
              param: _vm.sSDialogData
            },
            on: { setSSDialogData: _vm.onSetSSDialogData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3076997e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3076997e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/certiServicepopover.vue
// module id = MT5T
// module chunks = 14 17 23 24 27 29 31 41 42 43 47 50 60